import * as Sentry from '@sentry/react'
import axios from 'axios'
import { thirdPartyErrorFilterIntegration } from '@sentry/react'

const sentryDsn = import.meta.env.VITE_PUBLIC_SENTRY_DSN
const release =
  import.meta.env.VITE_APP_VERSION || import.meta.env.APP_VERSION || 'unknown'

export function initializeSentry() {
  Sentry.init({
    dsn: sentryDsn,
    release: release,
    integrations: [
      Sentry.browserTracingIntegration(),
      thirdPartyErrorFilterIntegration({
        filterKeys: ['returns-portal'],
        behaviour: 'drop-error-if-contains-third-party-frames'
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
    ignoreErrors: [
      "Can't find variable: showKeyboard",
      "Can't find variable: hideKeyboard",
      "Can't find variable: msDiscoverChatAvailable",
      'Cannot redefine property: BetterJsPop',
      /_avast_submit/i,
      /wpmobileappStopLoading/i
    ]
  })
}

export function notifyError(error: unknown) {
  if (axios.isAxiosError(error)) {
    const requestPayload = error?.config?.data
    const responsePayload = error.response?.data
    setTagsSentry({ endpoint: JSON.stringify(error.config?.url) })
    Sentry.captureException(error, {
      extra: {
        requestPayload: JSON.parse(requestPayload),
        responsePayload
      }
    })
  } else {
    Sentry.captureException(error)
  }
}

export function setUserSentry(email: string | undefined) {
  if (!email) return
  Sentry.setUser({
    email
  })
}

export function setTagsSentry(tags: { [key: string]: string }) {
  Sentry.setTags({
    ...tags
  })
}
